import { fullNameFormat, fullNameMinLength } from './fullName';
import { phoneNumberFormat, phoneNumberMaxLength } from './phoneNumber';
import getVisibleFields from '../elements/getVisibleFields';
import pick from 'lodash/pick';

const REQUIRED = '^Required';
const INVALID = '^Invalid';

/**
 * Returns all validation rules
 */
export const allValidationRules = () => {
  return {
    day_to_call: defaultRuleBuilder(),
    dialer_consent_accepted: presenceRuleBuilder(),
    email: emailRuleBuilder(),
    email_required: emailRuleBuilder(),
    full_name: fullNameRuleBuilder(),
    phone_number: phoneNumberRuleBuilder(),
    time_to_call: defaultRuleBuilder()
  };
};

/**
 * Returns validation rules for all visible fields in the form
 *
 * @param {Element} form
 */
export default function validationRules(form) {
  if (!form) return {};
  const visibleFieldNames = getVisibleFields(form).map(field => field.name);
  return pick(allValidationRules(), visibleFieldNames);
}

//
// Rule builders

/**
 * Returns default rule builder that has no validation
 */
export const defaultRuleBuilder = () => {
  return { presence: { allowEmpty: true } };
};

/**
 * Returns custom rule builder for email input
 */
export const emailRuleBuilder = () => {
  return {
    ...presenceRuleBuilder(),
    email: {
      message: INVALID
    }
  };
};

/**
 * Returns custom rule builder for full_name input
 */
export const fullNameRuleBuilder = () => {
  return {
    ...presenceRuleBuilder(),
    length: {
      minimum: fullNameMinLength(),
      message: REQUIRED
    },
    format: {
      pattern: fullNameFormat(),
      message: INVALID
    }
  };
};

/**
 * Returns custom rule builder for phone_number input
 */
export const phoneNumberRuleBuilder = () => {
  return {
    ...presenceRuleBuilder(),
    length: {
      maximum: phoneNumberMaxLength(),
      message: INVALID
    },
    format: {
      pattern: phoneNumberFormat(),
      message: INVALID
    }
  };
};

/**
 * Returns rule builder requiring presence
 */
export const presenceRuleBuilder = () => {
  return { presence: { message: REQUIRED, allowEmpty: false } };
};
